module.exports = __webpack_public_path__ + "media/application/images/icons/icon-retail-b589f65c5a3fe5cd62b79266150b681b.svg";